'use strict';

// Services
angular.module('dstreamApp.services', []);

angular.module('dstreamApp.controllers', ["ngTable", "flow"]).run(["editableOptions", "editableThemes", function (editableOptions, editableThemes) {
    editableThemes.bs3.buttonsClass = 'btn-xs';
    editableOptions.theme = 'bs3';
}]);
